/*
 * @Author: heyuan
 * @Date: 2020-08-19 16:35:09
 * @LastEditors: heyuan
 * @LastEditTime: 2020-10-16 09:34:21
 * @FilePath: \qida\src\net\config.js
 */
const config = {
  'offcn':'http://api.qianxunlife.com',
  'development': 'http://192.168.1.3:9091/',
  'prod': 'http://prod.sgn.qianxunlife.com/',
}
const configLive = {
  'offcn': 'http://api.qianxunlife.com/sinograin/lplay',
  // 'development': 'http://dev.live.sgn.7east.cn/sinograin/lplay',
  'development': 'https://wb.qianxunlife.com/#/',
  'prod': 'https://wb.qianxunlife.com/#/',
}
const configCommunity = {
  'offcn':'http://api.qianxunlife.com/sinograin/yici',
  'development': 'http://39.100.17.101',
  'prod': 'http://prod.sgn.qianxunlife.com',
}
const configCommunity2 = {
  'offcn':'http://api.qianxunlife.com/sinograin/yici',
  'development': 'http://39.100.17.101',
  'prod': 'http://sinograin.qianxunlife.com',
}
const type = "prod" // 正式和测试切换
export default {
  baseUrl: config[type], // 服务器接口
	liveUrl: configLive[type], //直播域名
  communityUrl: configCommunity[type], // 社区接口域名
  communityUrl2: configCommunity2[type], // 社区域名
 }



// WEBPACK FOOTER //
// ./src/net/config.js